import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import 'animation.gsap';
import { Power1, Power0, Power4, Linear, TweenMax } from "gsap/TweenMax";



export default () => {

    // init controller
    let controller = new ScrollMagic.Controller();

    let images = $('.img-wrapper');
    images.each((i, el) => {
        $(el).addClass('visible');
        let height = $(el).find('img').height();
        let width = $(el).find('img').width();
        var offset = $(el).attr('data-offset');
        if ($(window).width() <= 768) {
            offset = 100;
        }
        var fromY = $(el).attr('data-fromY');
        var toY = $(el).attr('data-toY');
        if ($(window).width() <= 768) {
            fromY = 0;
            toY = 0;
        }
        var css = {
            'width': 0 + 'px',
            'height': height + 'px'
        };
        // //console.log(css);
        $(el).find('.img-wrapper-bg').css(css);


        let css_wrapper = {
            "width": width + 'px',
            "background-size": width + 'px ' + height + 'px',
        };

        if ($(el).offset().top <= $(window).height()) {
            $(el).find('.img-wrapper-bg').css(css_wrapper).addClass('play');
        } else {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.9,
                offset: offset,
                duration: height * 2 + "px",
                //reverse:false
            })
                .setTween(TweenMax.fromTo($(el), 1, { y: fromY }, { y: toY, ease: Power0.easeInOut }))
                .addTo(controller)
                //.addIndicators({ name: `Animage ${$(el).attr('class')} Trigger` })
                .on("enter", (e) => {
                    let element = $(e.target.triggerElement());
                    i == 0 ? element.find('.img-wrapper-bg').css(css_wrapper).addClass('play') : element.find('.img-wrapper-bg').css(css_wrapper).addClass('play');
                });
        }
    });

};



// WEBPACK FOOTER //
// ./scripts/libs/image-wrapper.js